<template>
<div>
    <b-container>
        <transition name="fade">
            <div v-if="checkingAddress" class="loading">
                <p>Checking Your Address</p>
                </div>
        </transition>


        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Signing you up</p>
            </div>
        </transition>

        <!-- Top Message -->
        <!--
        <div  class="messageholder">
            <h3 style="text-align:center;color:#fff; padding-top:30px; padding-left:10px; padding-right:10px ">Kegs, Bottles, Cans from your Local Breweries</h3>
            <div style="text-align:center;color:#fff; padding:10px;"><span style="font-size:17px; font-weight:bold">A BREWER AND BUYER COMMUNITY</span></div>
        </div>
        -->
        
        <!-- Modal to display corrected address -->
        <b-row>
            <b-col>
                <b-modal no-fade size="l" id="modal-newaddress" title="We Found a Matching Address" 
                ok-title="Yes, Update"  @ok="submitAddress()">
                        <template v-slot:default="{ hide }">
                            <p>{{validatedAddress.street1}}</p>
                            <p>{{validatedAddress.street2}}</p>
                            <p>{{validatedAddress.zip}}</p>
                        </template>
                </b-modal>
            </b-col>
        </b-row>

        <b-row>
                <b-col>
                    <b-modal no-fade size="l" id="modal-invalidaddress" title="This Does Not Seem To Be a Valid Address" 
                    cancel-title="Use this address anyway" ok-title="Let me try again" @cancel="useInvalidAddress()">
                        Please check the address and try again
                    </b-modal>
                </b-col>
        </b-row>


        <div class='container'>
            <div class='row' style="margin-top:20px">
                <div  class='col-12'>
                    <h3>Get Started on Keg Seeker</h3>
                </div>
            </div>

            <div class='row' style="margin-top:20px; margin-bottom:20px">
                <div  class='col-12'>
                    Already have an account? <router-link to="/login"><u><font-awesome-icon icon="user-plus" style="margin-left:10px; margin-right:5px"/> Login</u></router-link> 
                </div>
            </div>

            <!-- Buyer sign up feedback -->
            <b-card v-if="startUserAccountFeedback" bg-variant="light" 
                class="mb-2"
            >
            <!-- Show if buyer, brewer or distributor -->
                <div class='row'>
                        <div v-if="isBrewer==1" class='col-12'>
                            <h6>You are a <i>Brewer</i></h6>
                        </div>
                        <div v-if="isBrewer==0" class='col-12'>
                            <h6>You are a <i>Buyer</i></h6>
                        </div>
                        <div v-if="isBrewer==2" class='col-12'>
                            <h6>You are a <i>Distributor</i></h6>
                        </div>
                        <div v-if="isBrewer==-1" class='col-12'>
                            <h6>You are a <i>Retail consumer</i>, buying beverages for personal use</h6>
                        </div>
                    
                        <transition name="fade">
                        <div v-if="showAddress||showEmail||showRadius" class='col-12'>
                            <h6>You are <i>{{name}}</i></h6>                           
                        </div>
                        </transition>
                        <!-- Showing address only for sellers -->
                        <div v-if="(isBrewer&&showRadius)||(isBrewer&&showEmail)" class='col-12'>
                            <h6>Your Address:<i> {{street1}} {{street2}}, {{city}}, {{addressState}}, {{zipcode}}</i></h6>
                        </div>

                        <div v-if="!isBrewer&&showEmail" class='col-12'>
                            <h6>Your Address: <i>{{street1}} {{street2}}, {{city}}, {{addressState}}, {{zipcode}}</i></h6>
                        </div>

                    <hr>
                </div>
            </b-card>
            

            <div class='row'>
                <!-- Check Brewer -->
                <div v-if='showBrewer' class='col-12'>
                    <h5>Are you a Brewery, a Buyer or a Distributor?</h5>
                    <table class='table'>
                        <tbody>
                            <tr @click="clickedIsBrewer(0)">
                                <td colspan='12'>
                                    <div class="bg-success ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">RETAILER</u>, buying beverages for resale (Bars, Pubs, Restaurants, Liquor Stores)</div>
                                </td>
                            </tr>

                            <tr @click="clickedIsBrewer(1)">
                                <td colspan='12'>
                                    <div class="bg-primary ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">BREWER</u> and I would like to sell my beverages</div>
                                </td>
                            </tr>


                            <tr v-if="allowDistributors"  @click="clickedIsBrewer(2)">
                                <td colspan='12'>
                                    <div class="bg-warning ksbutton isbrewerquestions">I am a <u style="font-weight:bolder">DISTRIBUTOR</u> selling multiple brands of beverages</div>
                                </td>
                            </tr>

                            
                            
                        </tbody>
                    </table>
                </div>
                </div>
                
                <!-- License and TOU -->
                <div v-if='showLicense'>
                    <div v-if='showLicenseWarning' class='inputwarning'>
                        Please check the options below
                    </div>
                    <div v-if='isBrewer==1' class='col-12'>
                        <b-form-group label="Do you certify you have a license to brew and sell the alcoholic beverages you will put up for sale??">
                        <b-form-checkbox-group
                            v-model="selectedLicenseBrewer"
                            :options="licenseOptions"
                            name="brewerLicense1"
                        ></b-form-checkbox-group>
                        </b-form-group>
                        <b-button class="btn btn-success" type="submit" @click="submitLicenseBrewer()">Next</b-button>
                    </div>
                    <div v-if='isBrewer<=0'  class='col-12'>
                        <b-form-group label="Do you certify you are legally allowed to buy alcoholic beverages?">
                        <b-form-checkbox-group
                            v-model="selectedLicensePub"
                            :options="licenseOptions"
                            name="brewerLicense2"
                        ></b-form-checkbox-group>
                        </b-form-group>
                        <b-button class="btn btn-success" type="submit" @click="submitLicensePub()">Next</b-button>
                    </div>

                    <div v-if='isBrewer==2'  class='col-12'>
                        <b-form-group label="Do you certify you have a license to buy and distribute the beverages you will put up for sale?">
                        <b-form-checkbox-group
                            v-model="selectedLicensePub"
                            :options="licenseOptions"
                            name="brewerLicense3"
                        ></b-form-checkbox-group>
                        </b-form-group>
                        <b-button class="btn btn-success" type="submit" @click="submitLicensePub()">Next</b-button>
                    </div>

        
                </div>
                <div v-if='showTerms'>
                    <div v-if='showTermsWarning' class='inputwarning'>
                        Please check the options below
                    </div>
                    
                    <b-form-group label="Do you accept our terms and conditions?">


                        <b-form-checkbox-group
                            v-model="selectedTerms"
                            :options="licenseOptions"
                            name="brewerLicense4"
                        ></b-form-checkbox-group>
                        </b-form-group>
                    <b-button class="btn btn-success" type="submit" @click="submitTerms()">Next</b-button>
                    <br>
                    <br>
                    <b-button v-b-modal.termsdetails> Show Terms And Conditions </b-button>
                    
                        <b-modal  class="test-modal"  no-fade  scrollable size="lg" id='termsdetails' title="Terms and Conditions" 
                            ok-only ok-title ='OK' >
                            <img src = "../assets/TOS-1.jpg">
                            <img src = "../assets/TOS-2.jpg">
                            <img src = "../assets/TOS-3.jpg">
                            <img src = "../assets/TOS-4.jpg">
                        </b-modal>

                    

                </div>
            
                <!-- End of check brewer -->

                <!-- Get name and license number-->
                <transition name="fade">
                    <div class='row'>
                        <div v-if='showName' class='col-12'>
                            <div>
                                <!-- Check for license only if buyer -->
                                <h3>What is your company's name? (enter your name if an individual buyer)</h3>
                                <b-form-input v-model="name" type="text" id="name" placeholder="Company Name"></b-form-input>
                                <div v-if="!checkNameCharacters" class="inputwarning">
                                    <p>Enter at least {{minNameCharacters}} characters</p>
                                </div>
                                <h6 style="margin-top:10px">(Optional) Contact Name</h6>
                                <b-form-input v-model="contactname" type="text" id="name" placeholder="Optional Contact Name"></b-form-input>

                                <div v-if="isBrewer==1">
                                    <b-button style="margin-top:10px" class="btn btn-success" type="submit" :disabled="!checkNameCharacters" @click="submitName()">Next</b-button>
                                </div>

                                <div v-else>
                                    <b-button  style="margin-top:10px" class="btn btn-success" type="submit" :disabled="!checkNameCharacters" @click="submitName()">Next</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <!-- End of get name -->
                
                <!-- Get Address-->
                <transition name="fade">
                    <div v-if='showAddress'>
                    <template>
                        <h3>What is Your Address</h3>
                        <small v-if="isBrewer==0">This is the address your beverages will be delivered to.</small>
                        <div>
                            <b-form-group
                            id="fieldset-horizontal"
                            label="Street Address 1"
                            label-for="input-1"
                            :invalid-feedback="invalidStreet"
                            :state="checkStreet1Length"
                            >
                            <b-form-input id="input-1" v-model="street1" :state="checkStreet1Length" trim></b-form-input>
                            </b-form-group>

                            <b-form-group
                            id="fieldset-horizontal"
                            label="Street Address 2"
                            label-for="input-street2"
                            >
                            <b-form-input id="input-street2" v-model="street2"></b-form-input>
                            </b-form-group>
                            

                            <b-form-group
                            id="fieldset-2"
                            label="City"
                            label-for="input-2"
                            :invalid-feedback="invalidCity"
                            :state="checkCityLength"
                            >
                            <b-form-input id="input-2" v-model="city" :state="checkCityLength" trim></b-form-input>
                            </b-form-group>
                            
                            <b-form-group
                            id="fieldset-3"
                            label="Zipcode"
                            label-for="input-3"
                            :invalid-feedback="invalidZip"
                            :state="checkZipLength"
                            >
                            <b-form-input maxlength="5" prepend="Zipcode" id="input-3" v-model="zipcode" :state="checkZipLength" placeholder="Zipcode"></b-form-input>
                            </b-form-group>

                            
                            <div class="mt-3" v-if="!addressState">Select your state</div>
                            <b-form-select style="width:200px" v-model="addressState" :options="statesList">
                            </b-form-select>
                            <br>

                            <div style='margin-top:10px'>
                                <b-button class="btn btn-success" type="submit" :disabled="!checkAddressValid" @click="checkAddress()">Next</b-button>
                            </div>

                        </div>

                    </template>
                    </div>
                </transition>
                <!-- End of get address-->

                <!-- Get Radius-->
                <transition name="fade">
                    <div v-if='showRadius'>
                        <template>
                            <div>
                                <!--Delivery Counties -->
                                <b-button style="margin-top:10px" variant="outline-info" v-b-modal.countieslist class="button">Select Counties To Deliver To</b-button>

                                <!-- Modal to select counties -->
                                <b-modal no-fade  scrollable size="xl" id= "countieslist" title="Select Counties" ok-only ok-variant="secondary" 
                                ok-title="Close" hide-footer 
                                
                                >
                                    <template v-slot:modal-header="{ close, ok }">
                                        <!-- Emulate built in modal header close button action -->
                                        <h5>Select Counties for Delivery</h5>
                                        <b-button variant="info" @click="ok()">
                                            <font-awesome-icon icon="check" /> Done Selecting
                                        </b-button>
                                        <b-button variant="outline-danger" @click="close()">
                                            Close
                                        </b-button>
                                    </template>

                                <b-row>
                                    <b-col>
                                        <template v-for="(county, index) in getCounties">
                                            <b-button style="margin:10px" :key="county.name+'selected'" v-if="county.isSelected" :pressed="true" variant="outline-warning" @click="removeCountyFromList(county.name)">{{county.name}}<font-awesome-icon icon="times" /></b-button>
                                            <b-button style="margin:10px" :key="county.name+'unselected'" v-else variant="outline-success" @click="addToCountyList(county.name, index)">{{county.name}}</b-button>
                                        </template>
                                    </b-col>
                                </b-row>

                                <!--
                                <div v-for="(county, index) in getCounties" :key="county.name">
                                    <div v-if="county.isSelected">
                                        <b-button :pressed="true" variant="outline-warning" @click="removeCountyFromList(county.name)">{{county.name}}<font-awesome-icon icon="times" /></b-button>
                                    </div>
                                    <div v-else>
                                        <b-button variant="outline-success" @click="addToCountyList(county.name, index)">{{county.name}}</b-button>
                                    </div>
                    
                                    <hr>
                                </div>
                                -->
                                <hr>
                                </b-modal>
                            <!-- End Of Delivery Counties -->

                            </div><hr>
                            <!-- Only breweries need to set a delivery method -->
                            <div v-if='isBrewer==1'>
                                <h5>How Do You Deliver Your Beers?</h5>

                                <div style="margin-top:10px" v-if='invalidDelivery' class='inputwarning'>Choose delivery method</div>
                                    <b-dropdown variant='dark' id="dropbowndelselect" text="Select A Distribution Method">
                                        <b-dropdown-item  v-for="(deliveryAgent) in getDeliveryAgents" :key="deliveryAgent" @click="deliveryMethod=deliveryAgent">{{deliveryAgent}}</b-dropdown-item>
                                        <b-dropdown-divider></b-dropdown-divider>
                                        <b-dropdown-item-button  v-b-modal.modalmoremethods >Other</b-dropdown-item-button>
                                    </b-dropdown>
                                    <h6>{{deliveryMethod}}</h6>
                                        <b-modal no-fade id= "modalmoremethods"  title="Other delivery method" ok-only ok-title="OK"  @ok="deliveryMethod=otherDeliveryMethod">
                                        <b-form-group
                                            class="mb-0"
                                            label-for="textarea-formatter-delivery"
                                            
                                        >
                                        <b-form-textarea
                                            id="textarea-formatter-delivery"
                                            v-model="otherDeliveryMethod"                    
                                        ></b-form-textarea>
                                    </b-form-group>
                                                        
                                    </b-modal>
                            </div>
                            <div>

                                <b-button class="btn btn-success" type="submit" :disabled="!checkRadiusValid||invalidDelivery" @click="submitRadius()">Next</b-button>
                            </div>

                        </template>
                    </div>
                </transition>

                <!-- Get email and password-->
                <transition name="fade">
                    <div class='row'>
                        <div v-if='showEmail'>
                            <div>
                                <!-- Phone Number -->
                                <b-form-group
                                id="fieldset-6"
                                label="Phone (required)"
                                label-for="input-7"
                                :invalid-feedback="invalidPhone"
                                :state="checkPhoneValid"
                                >
                                <b-form-input   id="input-7" v-model="phone" trim></b-form-input>
                                </b-form-group>

                                <!-- Email -->
                                <b-form-group
                                id="fieldset-4"
                                label="Email"
                                label-for="input-5"
                                :invalid-feedback="invalidEmail"
                                :state="checkEmailValid"
                                >
                                <b-form-input id="input-5" v-model="email" :state="checkEmailValid" trim></b-form-input>
                                </b-form-group>

                                <!-- Password -->
                                <b-form-group
                                id="fieldset-5"
                                label="Password"
                                label-for="input-6"
                                :invalid-feedback="invalidPassword"
                                :state="checkPasswordValid"
                                >
                                <b-form-input  type='password' id="input-6" v-model="password" :state="checkPasswordValid" trim></b-form-input>
                                </b-form-group>

                                
                            </div>
                            
                            <div class='row'>
                                <b-button class="btn btn-success" type="submit" :disabled="!checkEmailPasswordValid" @click="signUp()">Sign Up</b-button>
                            </div>

                    <div class='row inputwarning' v-if='errorMsg'>
                        Error!! {{errorMsg}}
                    </div>
                        </div>
                    </div>
                </transition>
                
        </div>
    </b-container>
    <footer><pagefooter/></footer>
</div>
    
</template>

<script>
    import { mapState } from 'vuex'

    import { currentUser } from '../firebaseConfig'
    import moment from 'moment'
    import { usStates } from './Myfunctions'
    import { updateuserinfo } from './Morefunctions'
    import Pagefooter from './Pagefooter'
    const fb = require('../firebaseConfig.js')
    import { checkAddress } from './Myfunctions'
    import { deliveryAgents } from './Myfunctions'
    import { californiaCountiesListold } from './Myfunctions'

    import { alabamaCountiesList } from '../counties/alabama'
    import { alaskaCountiesList } from '../counties/alaska'
    import { arizonaCountiesList } from '../counties/arizona'
    import { arkansasCountiesList } from '../counties/arkansas'
    import { californiaCountiesList } from '../counties/california'
    import { coloradoCountiesList } from '../counties/colorado'
    import { connecticutCountiesList } from '../counties/connecticut'
    import { delawareCountiesList } from '../counties/delaware'
    import { floridaCountiesList } from '../counties/florida'
    import { georgiaCountiesList } from '../counties/georgia'
    import { hawaiiCountiesList } from '../counties/hawaii'
    import { idahoCountiesList } from '../counties/idaho'
    import { illinoisCountiesList } from '../counties/illinois'
    import { indianaCountiesList } from '../counties/indiana'
    import { iowaCountiesList } from '../counties/iowa'
    import { kansasCountiesList } from '../counties/kansas'
    import { kentuckyCountiesList } from '../counties/kentucky'
    import { louisianaCountiesList } from '../counties/louisiana'
    import { maineCountiesList } from '../counties/maine'
    import { marylandCountiesList } from '../counties/maryland'
    import { massachussettsCountiesList } from '../counties/massachussetts'
    import { michiganCountiesList } from '../counties/michigan'
    import { minnesotaCountiesList } from '../counties/minnesota'
    import { mississippiCountiesList } from '../counties/mississippi'
    import { missouriCountiesList } from '../counties/missouri'
    import { montanaCountiesList } from '../counties/montana'
    import { nebraskaCountiesList } from '../counties/nebraska'
    import { nevadaCountiesList } from '../counties/nevada'
    import { newhampshireCountiesList } from '../counties/newhampshire'
    import { newjerseyCountiesList } from '../counties/newjersey'
    import { newmexicoCountiesList } from '../counties/newmexico'
    import { newyorkCountiesList } from '../counties/newyork'
    import { northcarolinaCountiesList } from '../counties/northcarolina'
    import { northdakotaCountiesList } from '../counties/northdakota'
    import { ohioCountiesList } from '../counties/ohio'
    import { oklahomaCountiesList } from '../counties/oklahoma'
    import { oregonCountiesList } from '../counties/oregon'
    import { pennsylvaniaCountiesList } from '../counties/pennsylvania'
    import { rhodeislandCountiesList } from '../counties/rhodeisland'
    import { southcarolinaCountiesList } from '../counties/southcarolina'
    import { southdakotaCountiesList } from '../counties/southdakota'
    import { tennesseeCountiesList } from '../counties/tennessee'
    import { texasCountiesList } from '../counties/texas'
    import { utahCountiesList } from '../counties/utah'
    import { vermontCountiesList } from '../counties/vermont'
    import { virginiaCountiesList } from '../counties/virginia'
    import { washingtonCountiesList } from '../counties/washington'
    import { westvirginiaCountiesList } from '../counties/westvirginia'
    import { wisconsinCountiesList } from '../counties/wisconsin'
    import { wyomingCountiesList } from '../counties/wyoming'

    export default {
        components: {
            Pagefooter,
        },

        data() {
            return {
                isBrewer:0,
                showBrewer:true,
                showLicense:false,
                showTerms:false,
                showName:false,
                showAddress:false,
                showDescription:false,
                showRadius:false,
                showEmail:false,
                minNameCharacters:4,
                name:'',
                contactname:'',
                phone:'',
                street1:'',
                street2:'',
                city:'',
                county:'',
                addressState:'',
                zipcode:'',
                submitNameStatus:'',
                submitAddressStatus:'',
                showNameWarning:true,
                showLicenseWarning:true,
                showLicenseWarning: false,
                showTermsWarning: false,
                inputAddressValid: false,
                email:'',
                password:'',
                radius:0,
                deliveryMethod:'',
                otherDeliveryMethod:'',
                performingRequest: false,
                theUserID:'',
                startUserAccountFeedback:false,
                statesList:[],
                errorMsg:'',
                selectedLicenseBrewer:[],
                selectedLicensePub:[],
                selectedTerms:[],
                termsAccepted:'',
                licenseAccepted:'',
                licenseOptions: [
                    { text: 'Yes', value: '1' },
                    { text: 'No', value: '0' },
                ],
                confirmedCanBrew:0,
                confirmedCanBuy:0,
                acceptedTerms:0,
                validatedAddress:{},
                checkingAddress :false,
                userCountiesList: [],
                userStatesList:[],
                counties: [],
            }
        },
        computed:{
            ...mapState(['allowDistributors', 'allowConsumers']),

            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },
            getCounties(){

                var allCounties = []
                if (this.addressState == 'AL') allCounties = alabamaCountiesList
                if (this.addressState == 'AK') allCounties = alaskaCountiesList
                if (this.addressState == 'AZ') allCounties = arizonaCountiesList
                if (this.addressState == 'AR') allCounties = arkansasCountiesList
                if (this.addressState == 'CA') allCounties = californiaCountiesList
                if (this.addressState == 'CO') allCounties = coloradoCountiesList
                if (this.addressState == 'CT') allCounties = connecticutCountiesList
                if (this.addressState == 'DE') allCounties = delawareCountiesList
                if (this.addressState == 'FL') allCounties = floridaCountiesList
                if (this.addressState == 'GA') allCounties = georgiaCountiesList
                if (this.addressState == 'HI') allCounties = hawaiiCountiesList
                if (this.addressState == 'ID') allCounties = idahoCountiesList
                if (this.addressState == 'IL') allCounties = illinoisCountiesList
                if (this.addressState == 'IN') allCounties = indianaCountiesList
                if (this.addressState == 'IA') allCounties = iowaCountiesList
                if (this.addressState == 'KS') allCounties = kansasCountiesList
                if (this.addressState == 'KY') allCounties = kentuckyCountiesList
                if (this.addressState == 'LA') allCounties = louisianaCountiesList
                if (this.addressState == 'ME') allCounties = maineCountiesList
                if (this.addressState == 'MD') allCounties = marylandCountiesList
                if (this.addressState == 'MA') allCounties = massachussettsCountiesList
                if (this.addressState == 'MI') allCounties = michiganCountiesList
                if (this.addressState == 'MN') allCounties = minnesotaCountiesList
                if (this.addressState == 'MS') allCounties = mississippiCountiesList
                if (this.addressState == 'MO') allCounties = missouriCountiesList
                if (this.addressState == 'MT') allCounties = montanaCountiesList
                if (this.addressState == 'NE') allCounties = nebraskaCountiesList
                if (this.addressState == 'NV') allCounties = nevadaCountiesList
                if (this.addressState == 'NH') allCounties = newhampshireCountiesList
                if (this.addressState == 'NJ') allCounties = newjerseyCountiesList
                if (this.addressState == 'NM') allCounties = newmexicoCountiesList
                if (this.addressState == 'NY') allCounties = newyorkCountiesList
                if (this.addressState == 'NC') allCounties = northcarolinaCountiesList
                if (this.addressState == 'ND') allCounties = northdakotaCountiesList
                if (this.addressState == 'OH') allCounties = ohioCountiesList
                if (this.addressState == 'OK') allCounties = oklahomaCountiesList
                if (this.addressState == 'OR') allCounties = oregonCountiesList
                if (this.addressState == 'PA') allCounties = pennsylvaniaCountiesList
                if (this.addressState == 'RI') allCounties = rhodeislandCountiesList
                if (this.addressState == 'SC') allCounties = southcarolinaCountiesList
                if (this.addressState == 'SD') allCounties = southdakotaCountiesList
                if (this.addressState == 'TN') allCounties = tennesseeCountiesList
                if (this.addressState == 'TX') allCounties = texasCountiesList
                if (this.addressState == 'UT') allCounties = utahCountiesList
                if (this.addressState == 'VT') allCounties = vermontCountiesList
                if (this.addressState == 'VA') allCounties = virgniaCountiesList
                if (this.addressState == 'WA') allCounties = washingtonCountiesList
                if (this.addressState == 'WV') allCounties = westvirginiaCountiesList
                if (this.addressState == 'WI') allCounties = wisconsinCountiesList
                if (this.addressState == 'WY') allCounties = wyomingCountiesList

                
                this.counties = []
                var arraySize = allCounties.length
                for (var i = 0; i<arraySize; i++){
                    var theCounty = {}
                    theCounty.name = allCounties[i]
                    var existingCountyindex = this.userCountiesList.findIndex(item => item === theCounty.name);
                    if (existingCountyindex > -1){
                        theCounty.isSelected = true
                    } 
                    else theCounty.isSelected = false
                    
                    this.counties.push(theCounty)
                }
                return this.counties
            },

            checkNameCharacters(){
                if (this.name.length >=this.minNameCharacters ) return true
                else return false
            },

            checkStreet1Length(){
                if (this.street1.length >5) return true
                else return false
            },
            invalidStreet(){
                if (this.street1.length > 5) {
                    return ''
                } else if (this.street1.length > 0) {
                    return 'Enter at least 6 characters'
                } else {
                    return 'Enter street address'
                    }
            },
            checkCityLength(){
                if (this.city.length >2) return true
                else return false
            },
            invalidCity(){
                if (this.city.length > 2) {
                    return ''
                } else if (this.city.length > 0) {
                    return 'Enter at least 3 characters'
                } else {
                    return 'Enter your city'
                    }
            },
            checkZipLength(){
                if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zipcode))
                    return true
                else return false
                //if(is_usZipCode(this.zip)) return true
                //else return false

            },
            invalidZip(){
                if (!(/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.zipcode))) return 'Enter a valid zipcode'
                else return ''
                /*
                if (this.zipcode.length == 5) {
                    return ''
                } else if (this.zipcode.length > 0) {
                    return 'Enter 5 characters'
                } else {
                    return 'Please enter zipcode'
                    }*/
            },


            checkStateLength(){
                if (this.addressState.length == 2) return true
                else return false
            },
            checkAddressValid(){
                if (this.checkNameCharacters&&this.checkZipLength&&this.checkStreet1Length&&this.checkCityLength&&this.checkStateLength) return true
                else return false
            },

            checkRadiusValid(){
                if (this.userCountiesList.length>0) return true
                else return false
            },
            invalidRadius(){
                if (this.radius>=10) {
                    return ''
                } else if (this.radius < 10) {
                    return 'At least 10 miles please'
                } else {
                    return 'Please enter delivery radius'
                    }
            },

            invalidDelivery(){
                //Only a brewer needs to set a delivery method
                if(this.isBrewer<=0||this.isBrewer==2) return false
                if (this.deliveryMethod.length < 1) return true
                else return false
            },

            //Check phone valid
            checkPhoneValid(){

                 if (/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(this.phone))
                    {
                        return (true)
                    }
                        return (false)
            },
            //Invalid phone feedback
            invalidPhone(){
                if (this.checkPhoneValid) 
                    return ''
                else 
                    return 'Please check the phone number'
            },

            //Check email valid
            checkEmailValid(){

                 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.email))
                    {
                        return (true)
                    }
                        return (false)
            },
            //Invalic email feedback
            invalidEmail(){
                if (this.checkEmailValid) 
                    return ''
                else 
                    return 'Please check the email address'
            },
            

            checkPasswordValid(){
                if (this.password.length >=8) return true
                else return false
            },

            invalidPassword(){
                if (this.checkPasswordValid) 
                    return ''
                else 
                    return 'Password must be at least 8 characters'
            },

            checkEmailPasswordValid(){
                if (this.checkEmailValid&&this.checkPasswordValid&&this.checkPhoneValid) return true
                else return false
            },
            setState(theState){
                this.addressState = theState

            }
        },

        methods: {
            clickedIsBrewer(brewerVal){
                
                this.statesList = []

                var arrayLength = usStates.length
                for (var i=0; i<arrayLength; i++) this.statesList.push(usStates[i].abbreviation)

                this.startUserAccountFeedback = true
                this.isBrewer=parseInt(brewerVal)
                
                this.showBrewer = false
                this.showLicense = true
                

            },

            submitLicenseBrewer(){
                if(this.selectedLicenseBrewer[0]!=1||this.selectedLicenseBrewer[1]){
                    this.showLicenseWarning = true
                    return
                }
                this.licenseAccepted = 1
                this.showLicenseWarning = false
                this.showLicense = false
                this.showTerms = true
            },
            submitLicensePub(){
                if(this.selectedLicensePub[0]!=1||this.selectedLicensePub[1]){
                    this.showLicenseWarning = true
                    return
                }
                this.showLicenseWarning = false
                this.licenseAccepted = 1
                this.showLicense = false
                this.showTerms = true
            },
            submitTerms(){
                if(this.selectedTerms[0]!=1||this.selectedTerms[1]){
                    this.showTermsWarning = true
                    return
                }
                this.showTermsWarning = false
                this.termsAccepted = 1
                this.showTerms = false
                this.showName = true

            },
            submitName(){
                this.showName= false
                this.showAddress = true
                
            },

            checkAddress(){
                if(!this.street2) this.street2 =''
                this.checkingAddress = true

                //Function to capitalize first letter of each word
                function titleCase(str) {
                    var splitStr = str.toLowerCase().split(' ');
                    for (var i = 0; i < splitStr.length; i++) {
                        // You do not need to check if i is larger than splitStr length, as your for does that for you
                        // Assign it back to the array
                        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
                    }
                    // Directly return the joined string
                    return splitStr.join(' '); 
                    }
                        var correctedAddress = checkAddress(this.street1, this.street2, this.city, this.zipcode, this.state).then(response => {
                        console.log("In response")
                        this.checkingAddress = false
                        if (response=='ERROR'){
                            console.log("ERROR")
                            this.$bvModal.show("modal-invalidaddress")
                        } 
                        else {
                            console.log(response.data)
                            var newAddress = response.data
                            if(newAddress.status=="INVALID"){
                                this.$bvModal.show("modal-invalidaddress")
                                return
                            }
                                

                            //New address found
                            else if (newAddress.status=="SUSPECT"){
                                newAddress.county = titleCase(newAddress.county)
                                this.validatedAddress.street1 = newAddress.addressline1
                                this.validatedAddress.county = titleCase(newAddress.county)
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = newAddress.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                this.validatedAddress.zip = newAddress.postalcode.substr(0, 5);
                                console.log("Updating address = ")
                                console.log(this.validatedAddress)
                                this.$bvModal.show("modal-newaddress")

                            }

                            //User entered a good address
                            else{
                                this.validatedAddress.street1 = newAddress.addressline1
                                if(this.validatedAddress.street2)
                                    this.validatedAddress.street2 = newAddress.addressline2
                                else
                                    this.validatedAddress.street2 = ""
                                this.validatedAddress.zip = newAddress.postalcode.substr(0, 5)
                                this.validatedAddress.county = titleCase(newAddress.county)
                                this.submitAddress()

                            }
                        }
                 })



            },
            useInvalidAddress(){

                this.validatedAddress.street1 = this.street1 
                if(this.validatedAddress.street2)
                    this.validatedAddress.street2 = this.street2
                else
                    this.validatedAddress.street2 = ""

                this.validatedAddress.zip = this.zipcode 
                console.log("Invaid address = ")
                console.log(this.validatedAddress)
                this.submitAddress()

            },

            submitAddress(){
                this.showAddress = false
                console.log("isbrewer = " + this.isBrewer)
                
                if (this.isBrewer>0) {
                    this.showRadius = true
                }
                else {
                    this.showEmail = true
                } 
                
            },

            submitRadius(){
                this.showRadius = false
                this.showEmail = true
            },
            addToCountyList(countyName, index){
                console.log("Adding to counties " + countyName )
                this.userCountiesList.push(countyName)

            },
            removeCountyFromList(countyName){
                var existingCountyindex = this.userCountiesList.findIndex(item => item === countyName);
                if (existingCountyindex > -1){
                    this.userCountiesList.splice(existingCountyindex,1)
                    }

            },


            signUp(){
                var shortName = ''
                shortName = this.name.toLowerCase()
                shortName = shortName.replace(/\s/g, '');
                shortName= shortName.replace(/[^\w\s]/gi, '')
                console.log("Short name is " + shortName)

                if(!this.deliveryMethod) this.deliveryMethod=""

                if (!this.street2) this.street2=''

                //subscriptionStatus=10 for brewers, 20 for distributors and 50 for buyers
                var subscriptionStatus = 50
                if(parseInt(this.isBrewer)==1) subscriptionStatus=10
                if(parseInt(this.isBrewer)==2) subscriptionStatus=20

                //Add user's state to states list
                var statesList = []
                statesList.push(this.addressState)

                this.performingRequest = true
                fb.auth.createUserWithEmailAndPassword(this.email, this.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    this.$store.commit('setIsBrewer', this.isBrewer)
                    this.theUserID = user.user.uid
                    var statesList = []
                    statesList.push(this.addressState)
                    var theUserProfile = 
                    {
                        name: this.name,
                        contactname:this.contactname,
                        phone:this.phone,
                        company: this.name,
                        email:this.email,
                        isbrewer: this.isBrewer,
                        city:this.city,
                        state:this.addressState,
                        street1:this.validatedAddress.street1,
                        street2:this.validatedAddress.street2,
                        zip:this.validatedAddress.zip,
                        county:this.validatedAddress.county,
                        favorites:[],
                        subscription:subscriptionStatus,
                        zipcodes:'',
                        events:[],
                        termsAccepted: this.termsAccepted,
                        licenseAccepted: this.licenseAccepted,
                        orderCount:0,
                        licenseUploaded:0,
                        licenseFile:'',
                        sendMarketingEmails:1,
                        sendOrderEmails:1,
                        shortName:shortName,
                        deliveryMethod:this.deliveryMethod,
                        breweries:'',
                        counties: this.userCountiesList,
                        states:statesList,
                        allowOrderNotifications:1,
                        allowPromoNotifications:1,
                        createdOn: new Date(),
                    }

                    // create user obj
                    fb.usersCollection.doc(user.user.uid).set(theUserProfile).then(() => {
                        this.$store.commit('setUserProfile', theUserProfile)
                        //Update sales tax etc
                        //updateuserinfo(user.user.uid,this.validatedAddress.zip)
                        
                        this.performingRequest = false
                        if (this.isBrewer==1) this.$router.push('/welcomepagebrewer')
                        else if (this.isBrewer==2) this.$router.push('/distributorinventory')
                        else this.$router.push('/welcomepagepub')
                        
                    }).catch(err => {
                        this.performingRequest = false
                        console.log("Error1 = "  + err.message)
                    })
                }).catch(err => {
                    this.performingRequest = false
                    this.errorMsg = err.message
                })

            },



        },
        
    }
</script>

<style scoped>
.modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
}

.isbrewerquestions {
    color: whitesmoke;
    padding:20px;
    cursor:pointer;
    font-size:20px;
    border:1px solid #f2f2f2;
    border-radius:20px
}

.test-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}

.ksbutton:hover {
    box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.25);
}

</style>
